import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT =
  process.env.REACT_APP_ENDPOINT + "/api/x-admin/balance-histories";

const getAllBalance = async (page = 1) => {
  const response = await axios.get(`${API_ENDPOINT}?page=${page}`, {
    withCredentials: true,

    headers: {
      ...authHeader(),
    },
  });

  return response.data;
};

const getAllBalanceWithSearch = async (page = 1,searchParam, searchQuery) => {
  const response = await axios.get(`${API_ENDPOINT}?page=${page}&${searchParam}=${searchQuery}`, {
    withCredentials: true,

    headers: {
      ...authHeader(),
    },
  });

  return response.data;
};
const balanceHistoryServices = {
  getAllBalance,
  getAllBalanceWithSearch
};
export default balanceHistoryServices;
